module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAIAAAD9b0jDAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAEZJREFUeNpi/P//PwO1ARMDDcCooaOGjho66A1lwSXx5MmTXbt2/fnzB59mFhY3NzcZGRl6uJRxtOgbNXTU0FFDqQUAAgwAW7kPMzSbpVsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/maptool/ZOOMIN_N.png
// module id = 58Fq
// module chunks = 18